export default "__VITE_ASSET__440310a2__"